import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './translate.js'
Vue.config.productionTip = true

import bulmaTabBar from './components/bulma_tabbar.vue'
import bulmaSubTab from './components/bulma_subtab.vue'
import bulmaModal from './components/bulma_modal.vue'
import bulmaContainer from './components/bulma_container.vue'
import bulmaTable from './components/bulma_table.vue'
import bulmaForm from './components/bulma_form.vue'
import bulmaRows from './components/bulma_rows.vue'
import bulmaBottomBar from './components/bulma_bottombar.vue'
import bulmaSections from './components/bulma_sections.vue'
import bulmaField from './components/bulma_field.vue'
import bulmaFieldSet from './components/bulma_fieldset.vue'
import bulmaFieldSet2 from './components/bulma_fieldset2.vue'
import bulmaActions from './components/bulma_actions.vue'
import bulmaMap from './components/bulma_map.vue'
import bulmaTimeline from './components/bulma_timeline.vue'
import bulmaPagination from './components/bulma_pagination.vue'
import bulmaActivities from './components/bulma_activities.vue'
import bulmaBuddy from './components/bulma_buddy.vue'
import bulmaHelp from './components/bulma_help.vue'
import bulmaGraph from './components/bulma_graph.vue'
import bulmaLocate from './components/bulma_locate.vue'
import bulmaSimpleTable from './components/bulma_simpletable.vue'
import bulmaGoogleMyBusiness from './components/bulma_googleMyBusiness.vue'
import bulmaEmpty from './components/bulma_empty.vue'
import bulmaApproval from './components/bulma_approval.vue'
import notificationManager from './components/notificationManager.vue'
import bulmaConversion from './components/bulma_conversion.vue'
import bulmaMapwithmarkers from './components/bulma_mapwithmarkers.vue'
import bulmaUpload from './components/bulma_upload.vue'
import bulmaReminder from './components/bulma_reminder.vue'
import bulmaIframe from './components/bulma_iframe.vue'
import bulmaTableWriteInline from './components/bulma_table_writeinline.vue'
import bulmaFieldContext from './components/bulma_field_context.vue'
import bulmaP from './components/bulma_p.vue'
import bulmaPivot from './components/bulma_pivot.vue'
import bulmaOneImageHtml from './components/bulma_oneImageHtml.vue'
import bulmaCalendar from './components/bulma_calendar.vue'

import bulmaCamera from './components/bulma_camera.vue'
import bulmaPictures from './components/bulma_pictures.vue'
import bulmaPicturesManager from './components/bulma_picturesmanager.vue'
import bulmaPicturesUpload from './components/bulma_pictureupload.vue'
import bulmaPicturesViewer from './components/bulma_pictureviewer.vue'

import bulmaWizardContainer from './components/bulma_wizard_container.vue'
import bulmaFieldSetInternalStore from './components/bulma_fieldset_IS.vue'
import bulmaTableInternalStore from './components/bulma_table_IS.vue'
import bulmaFieldInternalStore from './components/bulma_field_IS.vue'
import wizardClaimLine from './components/wizard_claim_line.vue'


Vue.component('bulmaBottomBar', bulmaBottomBar);
Vue.component('bulmaTabBar', bulmaTabBar);
Vue.component('bulmaSubTab', bulmaSubTab);
Vue.component('bulmaModal', bulmaModal);
Vue.component('bulmaContainer', bulmaContainer);
Vue.component('bulmaTable', bulmaTable);
Vue.component('bulmaForm', bulmaForm);
Vue.component('bulmaRows', bulmaRows);
Vue.component('bulmaSections', bulmaSections);
Vue.component('bulmaField', bulmaField);
Vue.component('bulmaFieldSet', bulmaFieldSet);
Vue.component('bulmaFieldSet2', bulmaFieldSet2);
Vue.component('bulmaActions', bulmaActions);
Vue.component('bulmaMap', bulmaMap);
Vue.component('bulmaTimeline', bulmaTimeline);
Vue.component('bulmaPagination', bulmaPagination);
Vue.component('bulmaActivities', bulmaActivities);
Vue.component('bulmaBuddy', bulmaBuddy);
Vue.component('bulmaHelp', bulmaHelp);
Vue.component('bulmaGraph', bulmaGraph);
Vue.component('bulmaLocate', bulmaLocate);
Vue.component('bulmaSimpleTable', bulmaSimpleTable);
Vue.component('bulmaEmpty', bulmaEmpty);
Vue.component('bulmaHelp', bulmaHelp);
Vue.component('bulmaLocate', bulmaLocate);
Vue.component('bulmaSimpleTable', bulmaSimpleTable);
Vue.component('bulmaGoogleMyBusiness', bulmaGoogleMyBusiness);
Vue.component('bulmaApproval', bulmaApproval);
Vue.component('bulmaConversion', bulmaConversion);
Vue.component('notificationManager', notificationManager);
Vue.component('bulmaMapwithmarkers', bulmaMapwithmarkers);
Vue.component('bulmaUpload', bulmaUpload);
Vue.component('bulmaReminder', bulmaReminder);
Vue.component('bulmaIframe', bulmaIframe);
Vue.component('bulmaTableWriteInline', bulmaTableWriteInline);
Vue.component('bulmaFieldContext', bulmaFieldContext);
Vue.component('bulmaCamera', bulmaCamera);
Vue.component('bulmaPictures', bulmaPictures);
Vue.component('bulmaPicturesManager', bulmaPicturesManager);
Vue.component('bulmaPicturesUpload', bulmaPicturesUpload);
Vue.component('bulmaPicturesViewer', bulmaPicturesViewer);
Vue.component('bulmaP', bulmaP);
Vue.component('bulmaPivot', bulmaPivot);
Vue.component('bulma_oneImageHtml', bulmaOneImageHtml);
Vue.component('bulmaCalendar', bulmaCalendar);

Vue.component('bulmaWizardContainer', bulmaWizardContainer);
Vue.component('bulmaTableInternalStore', bulmaTableInternalStore);
Vue.component('bulmaFieldSetInternalStore', bulmaFieldSetInternalStore);
Vue.component('bulmaFieldInternalStore', bulmaFieldInternalStore);
Vue.component('wizardClaimLine', wizardClaimLine);

import semanticRows from './components/semantic_rows.vue'
Vue.component('semanticRows', semanticRows);

import semanticHelp from './components/semantic_help.vue'
Vue.component('semanticHelp', semanticHelp);

import semanticTabBar from './components/semantic_tabbar.vue'
Vue.component('semanticTabBar', semanticTabBar);

import ionicTabBar from './components/ionic_tabbar.vue'
Vue.component('ionicTabBar', ionicTabBar);

Object.defineProperty(Vue.prototype, '$clientConfig', {
  get() {
    return store.getters.clientConfig || {};
  }
});

var myApp = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.myApp = myApp;

import numeral from 'numeral'

if (numeral.locales['it'] === undefined) {
  numeral.register('locale', 'it', {
    delimiters: { thousands: '.', decimal: ',' },
    abbreviations: { thousand: 'k', million: 'm', billion: 'b', trillion: 't' },
    currency: { symbol: '€' }
  });

}

if (numeral.locales['us'] === undefined) {
  numeral.register('locale', 'us', {
    delimiters: { thousands: ',', decimal: '.' },
    abbreviations: { thousand: 'k', million: 'm', billion: 'b', trillion: 't' },
    currency: { symbol: '$' }
  });
}

numeral.locale('it');


//per mandare notifiche
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/service-worker.js', { scope: '/'})
    .then((registration) => {
      console.log('Service Worker registrato con successo:', registration);

      // Verifica se il browser supporta PushManager
      if ('PushManager' in window) {
        console.log('notification supported by browser');
      }
    })
    .catch((error) => {
      console.error('Errore nella registrazione del Service Worker:', error);
    });
} else {
  console.error('notification not supported by browser.');
}


/*
router.afterEach(( to, from ) => {
//  console.log('ga:'+to.path)
});
*/

